import Box from '@mui/material/Box'
import type { LaunchAudienceTag } from '../lib/launchSurveyMetadata'

const TAG_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  height: 26,
  px: '9px',
  borderRadius: '9999px',
  bgcolor: '#ebeff7',
  color: '#6c727e',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  whiteSpace: 'nowrap',
} as const

const DISTRICT_TAG_SX = {
  ...TAG_SX,
  px: '14px',
  bgcolor: '#fdefd6',
  color: '#e9a239',
} as const

function tagSx(tone: LaunchAudienceTag['tone']) {
  return tone === 'district' ? DISTRICT_TAG_SX : TAG_SX
}

interface Props {
  tags: LaunchAudienceTag[]
  testId: string
}

export function LaunchAudienceFilterTags({ tags, testId }: Readonly<Props>) {
  return (
    <Box
      data-testid={testId}
      sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', minWidth: 0, width: '100%' }}
    >
      {tags.map((tag) => (
        <Box key={tag.label} component="span" sx={tagSx(tag.tone)}>
          {tag.label}
        </Box>
      ))}
    </Box>
  )
}
